import { saveAs } from "file-saver";
import Papa from "papaparse";

import { ECPLastImportJob } from "../types/ecp";
import { authFetcher } from "./../utils/auth-fetch";

const API_ENDPOINT = import.meta.env.VITE_API_ENDPOINT;

const uploadImage = async (payload: any) => {
  return await authFetcher<any>("POST", `upload/image`, payload, null, {
    "Cache-Control": "no-cache",
  });
};

const downloadImage = async (fileName: string) => {
  return await authFetcher<any>(
    "GET",
    `download/image/${fileName}`,
    null,
    null,
    {
      "Cache-Control": "no-cache",
    },
    false,
    undefined,
    null,
    "blob",
  );
};

const uploadECP = async (payload: any) => {
  return await authFetcher<any>("POST", `upload/ecp`, payload, null, {
    "Cache-Control": "no-cache",
  });
};

const getLastImportJob = async () => {
  return await authFetcher<ECPLastImportJob>("GET", `upload/ecp/last-job`);
};

const getDownloadImportResult = async (fileName: string) => {
  return await authFetcher<any>(
    "GET",
    `download/ecp-import-result/${fileName}`,
  );
};

const downloadECP = async () => {
  const response = await authFetcher<any>("GET", `download/ecp`);
  if (response) {
    const parsedData = Papa.parse(response, { header: true }).data;
    const csv = Papa.unparse(parsedData);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, "data.csv");
  }
};

const viewImage = (fileName: string) => {
  return `${API_ENDPOINT}/download/image/${fileName}`;
};

export {
  downloadECP,
  downloadImage,
  getDownloadImportResult,
  getLastImportJob,
  uploadECP,
  uploadImage,
  viewImage,
};
